// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bDKA","right":"styles_right__2eq0l"};